(function () {
  'use strict';

  function init() {
    var container = document.getElementById('fm-logo-3d');
    if (!container) return;
    var speedMult = parseFloat(container.dataset.speed || 100) / 100;
    if (typeof THREE === 'undefined' || typeof THREE.GLTFLoader === 'undefined') {
      setTimeout(init, 100);
      return;
    }

    var H = container.offsetHeight || 64;
    var W = Math.round(H * 1.8);

    // ── Renderer ──
    var renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.setSize(W, H);
    renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.4;
    container.appendChild(renderer.domElement);

    // ── Scene / Camera ──
    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(38, W / H, 0.01, 1000);
    camera.position.set(0, 0, 6);

    // ── Lights ──
    scene.add(new THREE.AmbientLight(0xffffff, 0.6));

    var key = new THREE.DirectionalLight(0xffffff, 1.8);
    key.position.set(2, 3, 4);
    scene.add(key);

    var fill = new THREE.DirectionalLight(0xc9a84c, 0.5);
    fill.position.set(-2, -1, 2);
    scene.add(fill);

    // ── Dark metallic material ──
    var goldMat = new THREE.MeshStandardMaterial({
      color: 0x111111,
      metalness: 0.85,
      roughness: 0.18,
    });

    // ── Load GLB ──
    var glbUrl = container.dataset.glb;
    var modelGroup = null;

    var loader = new THREE.GLTFLoader();
    loader.load(
      glbUrl,
      function (gltf) {
        var model = gltf.scene;

        // Swap all materials to gold
        model.traverse(function (child) {
          if (child.isMesh) {
            child.material = goldMat;
          }
        });

        // Center + scale to fill view
        var box3 = new THREE.Box3().setFromObject(model);
        var center = box3.getCenter(new THREE.Vector3());
        var size = box3.getSize(new THREE.Vector3());
        var maxDim = Math.max(size.x, size.y, size.z);
        var scale = 2.6 / maxDim;
        model.position.sub(center);
        model.scale.setScalar(scale);

        // Blender Z-up to Three.js Y-up correction
        model.rotation.x = Math.PI / 2;

        modelGroup = new THREE.Group();
        modelGroup.add(model);
        scene.add(modelGroup);
      },
      undefined,
      function (err) { console.warn('FM GLB load error', err); }
    );

    // ── Interaction ──
    var isDragging = false;
    var prevX = 0, prevY = 0;
    var velX = 0, velY = 0;
    var rotX = 0.12, rotY = 0;
    var dragDist = 0;
    var canvas = renderer.domElement;
    canvas.style.cursor = 'grab';

    canvas.addEventListener('mousedown', function (e) {
      isDragging = true;
      prevX = e.clientX; prevY = e.clientY;
      velX = 0; velY = 0; dragDist = 0;
      canvas.style.cursor = 'grabbing';
      e.preventDefault();
    });
    window.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      var dx = e.clientX - prevX;
      var dy = e.clientY - prevY;
      dragDist += Math.abs(dx) + Math.abs(dy);
      velX = dx * 0.014;
      velY = dy * 0.014;
      rotY += velX;
      rotX += velY;
      prevX = e.clientX; prevY = e.clientY;
    });
    window.addEventListener('mouseup', function () {
      isDragging = false;
      canvas.style.cursor = 'grab';
    });

    // Touch
    var touchStartX = 0, touchStartY = 0, touchStartTime = 0;
    canvas.addEventListener('touchstart', function (e) {
      isDragging = true;
      prevX = e.touches[0].clientX; prevY = e.touches[0].clientY;
      touchStartX = prevX; touchStartY = prevY;
      touchStartTime = Date.now();
      velX = 0; velY = 0; dragDist = 0;
    }, { passive: true });
    canvas.addEventListener('touchmove', function (e) {
      if (!isDragging) return;
      var dx = e.touches[0].clientX - prevX;
      var dy = e.touches[0].clientY - prevY;
      dragDist += Math.abs(dx) + Math.abs(dy);
      velX = dx * 0.014;
      velY = dy * 0.014;
      rotY += velX;
      rotX += velY;
      prevX = e.touches[0].clientX; prevY = e.touches[0].clientY;
      e.preventDefault();
    }, { passive: false });
    canvas.addEventListener('touchend', function () { isDragging = false; });

    // ── Render loop ──
    function animate() {
      requestAnimationFrame(animate);
      if (modelGroup) {
        if (!isDragging) {
          var friction = 1 - ((1 - 0.91) * speedMult);
          velX *= friction;
          velY *= friction;
          rotY += velX;
          rotX += velY;
          // Gentle idle spin
          if (Math.abs(velX) < 0.0015) rotY += 0.004 * speedMult;
          // Ease back to slight forward tilt
          rotX += (0.12 - rotX) * 0.025;
        }
        rotX = Math.max(-1.3, Math.min(1.3, rotX));
        modelGroup.rotation.y = rotY;
        modelGroup.rotation.x = rotX;
      }
      renderer.render(scene, camera);
    }
    animate();

    // ── Resize ──
    window.addEventListener('resize', function () {
      var h = container.offsetHeight || 64;
      var w = Math.round(h * 1.8);
      renderer.setSize(w, h);
      camera.aspect = w / h;
      camera.updateProjectionMatrix();
    });
  }

  // Boot as soon as DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
